import type { RegionCode } from 'google-libphonenumber';
import { PhoneUtil } from './phone';

export type CountryCode = `+${number}`;

export interface Country {
  countryCode: CountryCode;
  fullName: string;
  isoCode: RegionCode;
}
const REGION_NAMES = new Intl.DisplayNames(['en'], { type: 'region' });

let countries = [] as Country[];

export const getCountryFullName = (isoCode: RegionCode) => REGION_NAMES.of(isoCode);

export const getCountries = (filteredCountries?: RegionCode[]) => {
  const isoCodes = PhoneUtil.getSupportedRegions();
  countries = isoCodes
    .map((isoCode) => {
      const countryCode = `+${PhoneUtil.getCountryCodeForRegion(isoCode)}` as const;
      const fullName = getCountryFullName(isoCode);
      if (!fullName) throw new Error(`Failed getting country full name with isoCode ${isoCode}`);
      return {
        countryCode,
        fullName,
        isoCode,
      };
    })
    .sort((a, b) => a.fullName.localeCompare(b.fullName));

  if (filteredCountries) {
    countries = countries.filter(({ isoCode }) => filteredCountries.includes(isoCode));
  }

  return countries;
};

export const getCountriesForComboBox = (filteredCountries?: RegionCode[]) => {
  const countries = getCountries(filteredCountries);
  return countries.map(({ isoCode, fullName, countryCode }) => ({
    title: getEmojiFromIsoCode(isoCode),
    value: isoCode,
    itemDescription: `${fullName} (${countryCode})`,
  }));
};

export const getEmojiFromIsoCode = (isoCode: RegionCode) =>
  isoCode
    .toUpperCase()
    .split('')
    .map((char) =>
      // Get the regional indicator symbol by offsetting from the ASCII code of 'A'
      String.fromCodePoint(char.charCodeAt(0) + 127397)
    )
    .join('');
